import { LegalDocumentView } from '../components/legal/LegalDocumentView';
import { TERMS_CONTENT } from '../content/terms';
import { usePageSeo } from '../hooks/usePageSeo';
import { PAGE_SEO } from '../lib/seo';

export function TermsPage() {
  usePageSeo(PAGE_SEO.terms);

  return <LegalDocumentView document={TERMS_CONTENT} />;
}
